module.exports = __webpack_public_path__ + "static/media/Woodgate-Condo-Master-Deed.259145fd.pdf";